var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Transition", { attrs: { name: "dynamic-table__modal--unfold" } }, [
    _c(
      "div",
      {
        staticClass: "dynamic-table__overlay",
        attrs: { "data-flow-direction": _vm.flowDirection },
        on: {
          click: function($event) {
            return _vm.$emit("close")
          }
        }
      },
      [
        _c(
          "div",
          {
            staticClass: "dynamic-table__modal",
            style: _vm.modalWidth ? "--modal-width:" + _vm.modalWidth : "",
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c("div", { staticClass: "dynamic-table__selected" }, [
              _c("div", { staticClass: "dynamic-table__header" }, [
                _c("h5", [_vm._v("Editando fila")]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-light",
                    style: _vm.notClickToClose ? "display: none;" : "",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fa fa-close" }),
                    _c("span", [_vm._v("Cerrar")])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dynamic-table__body" }, [
                _c("h5", { staticClass: "dynamic-table__title" }, [
                  _vm._v("\n            " + _vm._s(_vm.title) + "\n          ")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dynamic-table__content",
                    attrs: {
                      "data-has-vue-modal": _vm.hasVueModal ? "true" : "false"
                    }
                  },
                  [
                    _vm.hasVueModal
                      ? _vm._t("default")
                      : _vm._t("default", null, { selectedRow: _vm.value })
                  ],
                  2
                )
              ])
            ])
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8e24e8e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8e24e8e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/DynamicTable.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c8e24e8e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/DynamicTable.vue
// module chunks = 0